module.exports = __webpack_public_path__ + "static/media/logo_fullcam_white.bea05b53.svg";